export default __webpack_public_path__ + "img/3aa3ff1.svg";